export const allowedTypes = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  // "application/msword", // .doc
];

export const allowedExtensions = [".pdf", ".docx", ".xlsx"];

// Letterhead images: PNG, JPEG, JPG (for DOCX template merging)
export const letterheadImageTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
];

export const letterheadImageExtensions = [".png", ".jpeg", ".jpg"];

export const isFileTypeAllowed = (file) => {
  if (allowedTypes.includes(file.type)) return true;

  const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  return allowedExtensions.includes(ext);
};

export const isLetterheadImageAllowed = (file) => {
  if (letterheadImageTypes.includes(file.type)) return true;

  const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  return letterheadImageExtensions.includes(ext);
};
